import { getRandomInteger } from "./get-random-integer";

export const shuffleArray = (array: unknown[], shuffledArray: unknown[] = []): unknown[] => {
    if (!Array.isArray(array)) return array;
    if (array.length <= 0) return shuffledArray;

    const randomNumber = getRandomInteger(0, array.length - 1);
    const selectedElement = array[randomNumber];

    return shuffleArray(
        array.filter((_, i) => i !== randomNumber),
        [...shuffledArray, selectedElement],
    );
};
